import { render, staticRenderFns } from "./Well.vue?vue&type=template&id=654c8b5f&scoped=true&"
import script from "./Well.vue?vue&type=script&lang=js&"
export * from "./Well.vue?vue&type=script&lang=js&"
import style0 from "./Well.vue?vue&type=style&index=0&id=654c8b5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c8b5f",
  null
  
)

export default component.exports